import { __assign } from "tslib";
import React from 'react';
import { normalizePremiumFolderData } from '../../utils/normalizePremiumFolderData';
import HiddenDumbView from './Hidden';
import PremiumDumbView from './Premium';
import { useDeviationMatureFilter } from '../../utils/hooks/useDeviationMatureFilter';
export function useDumboCommon(props) {
    var _a;
    var showBlocked = useDeviationMatureFilter(props.deviation).showBlocked;
    if (!props.deviation) {
        return null;
    }
    if (showBlocked && !props.showMatureContent) {
        return React.createElement(HiddenDumbView, __assign({}, props));
    }
    var isPremiumLocked = normalizePremiumFolderData((_a = props.deviation) === null || _a === void 0 ? void 0 : _a.premiumFolderData).isPremiumLocked;
    if (isPremiumLocked) {
        return React.createElement(PremiumDumbView, __assign({}, props));
    }
}
//# sourceMappingURL=useDumbo.js.map